import { render, staticRenderFns } from "./FinanceMain.vue?vue&type=template&id=5481c7a4&"
import script from "./FinanceMain.vue?vue&type=script&lang=js&"
export * from "./FinanceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports